import type { ComponentProps } from 'react'

export const RepeatIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color="currentColor"
      {...props}
    >
      <path
        d="M14.517 3.675H4.492L6.058 2.11a.629.629 0 0 0 0-.884.629.629 0 0 0-.883 0L2.542 3.86a.647.647 0 0 0-.184.441.647.647 0 0 0 .183.442l2.634 2.633a.618.618 0 0 0 .442.184.618.618 0 0 0 .441-.184.629.629 0 0 0 0-.883L4.492 4.925h10.025c1.033 0 1.875.842 1.875 1.875v2.767a.63.63 0 0 0 .625.625.63.63 0 0 0 .625-.625V6.8c0-1.725-1.4-3.125-3.125-3.125Z"
        fill="currentColor"
      />
      <path
        d="M17.642 15.7a.646.646 0 0 0-.183-.442l-2.634-2.633a.629.629 0 0 0-.883 0 .629.629 0 0 0 0 .883l1.566 1.567H5.483A1.878 1.878 0 0 1 3.608 13.2v-2.767a.63.63 0 0 0-.625-.625.63.63 0 0 0-.625.625V13.2c0 1.725 1.4 3.125 3.125 3.125h10.025l-1.566 1.566a.629.629 0 0 0 0 .884.618.618 0 0 0 .441.183.618.618 0 0 0 .442-.183l2.633-2.634a.646.646 0 0 0 .184-.441Z"
        fill="currentColor"
      />
    </svg>
  )
}
